import React, { useEffect, useState } from "react";
import { getCodeFromUrl } from "../../../../../../utils/helper";
import { getRenewalTitle } from "../../../../../../service/renewal/renewalService";
import { useSelector } from "react-redux";
import { api_strapi } from "../../../../../../utils/interface";
import "./index.scss"

function Whyupgrade() {
  const [whyUpgrade, setUpgrade] = useState([]);
  let agCode = getCodeFromUrl();
  const renewalTitle = useSelector((state) => state.renewal.renewalTitles);

  useEffect(() => {
    const upgrade = async () => {
      const response = await api_strapi.get(
        `${process.env.REACT_APP_STRIPI_URL}/ags?filters[slug][$eq]=${agCode}&populate=why_to_upgrades,why_to_upgrades.image`
      );

      if (response && response.status === 200) {
        setUpgrade(response?.data?.data[0]?.attributes?.why_to_upgrades?.data);
      }
    };
    upgrade();
  }, [agCode]);

  useEffect(() => {
    const getTitles = async () => {
      await getRenewalTitle();
    };
    getTitles();
  }, []);

  return (
    <div className="upgrade-container">
      <h3>{renewalTitle?.whyToUpgrade}</h3>
      <div className="coverage-container">
        {whyUpgrade?.map((item, index) => (
          <div className="coverage">
            <img
              className="coverage-img"
              src={item?.attributes?.image?.data?.attributes?.url}
              alt=""
            />
            <p>{item?.attributes?.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Whyupgrade;
